export default __webpack_public_path__ + "static/media/10.db1e9701.jpg";